import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useScreenContext, Option } from "../Layout";

function Usage() {
  const { t } = useTranslation();
  const [screenData, setScreenData] = useScreenContext();

  useEffect(() => {
    setScreenData(() => ({
      ...screenData,
      submitLabel: t("layout.cta_continue"),
      nextPath: "time",
      progress: 28,
    }));
  }, []);

  const handleOptionSelection = (option: string) => {
    setScreenData(() => ({
      ...screenData,
      userPreferences: {
        ...screenData.userPreferences,
        usage: option,
      },
    }));
  };

  return (
    <div>
      <h1 className="mb-4 text-2xl font-bold tracking-tight text-gray-900 dark:text-white md:text-5xl">
        {t("usage.headline")}
      </h1>
      <div className="mt-10 grid grid-cols-2 gap-5">
        <Option onClick={() => handleOptionSelection("After waking up")}>
          {t("usage.option_1")}
          <div className="text-4xl">☕</div>
        </Option>
        <Option onClick={() => handleOptionSelection("While working out")}>
          {t("usage.option_2")}
          <div className="text-4xl">🏃</div>
        </Option>
        <Option onClick={() => handleOptionSelection("On your daily commute")}>
          {t("usage.option_3")}
          <div className="text-4xl">🚙</div>
        </Option>
        <Option onClick={() => handleOptionSelection("While taking a break")}>
          {t("usage.option_4")}
          <div className="text-4xl">🛋️</div>
        </Option>
      </div>
    </div>
  );
}

export default Usage;
